import {
  FETCH_TRANSACTION_REPORT_COLUMNS_LIST,
  RESET_TRANSACTION_REPORT_COLUMNS_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
};

const transactionReportColumnsList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSACTION_REPORT_COLUMNS_LIST:
      return { list: action.payload, others: action.others };
    case RESET_TRANSACTION_REPORT_COLUMNS_LIST:
      return initialState;
    default:
      return state;
  }
};

export default transactionReportColumnsList;
